/**
 * Cartão de Encontro — ficha 707 do sistema Acervo.
 * Borda perfurada evoca o cartão de devolução colado na contracapa de
 * livros de biblioteca; o carimbo de data substitui o badge redondo comum.
 */
import { cn } from '@/lib/utils';

const MONTHS_PT = [
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ',
];

export default function LiteraryEventCard({
  date,
  title,
  time,
  location,
  seatsFilled,
  seatsTotal,
  onClick,
  className,
}) {
  const day = date.getDate();
  const month = MONTHS_PT[date.getMonth()];

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'relative w-full max-w-[300px] rounded border border-linen bg-paper pl-6 text-left shadow-sm',
        'transition-shadow hover:shadow-md',
        className,
      )}
    >
      {/* Borda perfurada — cartão de devolução */}
      <span
        aria-hidden="true"
        className="absolute inset-y-0 left-0 w-6 border-r border-dashed border-outline"
        style={{
          backgroundImage:
            'radial-gradient(circle, var(--color-paper-warm) 2.5px, transparent 2.6px)',
          backgroundSize: '100% 18px',
          backgroundPosition: 'center',
        }}
      />

      <div className="py-5 pl-3 pr-5">
        <div
          className="mb-3.5 flex h-13 w-13 -rotate-6 items-center justify-center rounded-full border-[1.5px] border-wine text-center font-serif text-sm leading-tight text-wine tabular-nums"
          style={{ width: 52, height: 52 }}
        >
          {day}
          <br />
          {month}
        </div>

        <p className="font-serif text-base text-ink">{title}</p>
        <p className="mt-1 text-[13px] leading-relaxed text-graphite">
          {time}
          <br />
          {location}
        </p>

        {seatsTotal != null && (
          <span className="mt-3 inline-block rounded bg-blush-light px-2 py-1 text-[11px] text-wine-deep tabular-nums">
            {seatsFilled} de {seatsTotal} vagas preenchidas
          </span>
        )}
      </div>
    </button>
  );
}
